/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamAnswerAnsweridAiCorrectionMutationResponse,
  PostApiV1ExamAnswerAnsweridAiCorrectionPathParams,
  PostApiV1ExamAnswerAnsweridAiCorrection400,
  PostApiV1ExamAnswerAnsweridAiCorrection401,
  PostApiV1ExamAnswerAnsweridAiCorrection404,
  PostApiV1ExamAnswerAnsweridAiCorrection500,
} from "../../types/examCorrectionDashboardController/PostApiV1ExamAnswerAnsweridAiCorrection.ts";

function getPostApiV1ExamAnswerAnsweridAiCorrectionUrl(
  answerId: PostApiV1ExamAnswerAnsweridAiCorrectionPathParams["answerId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/exam/answer/${answerId}/ai-correction` as const,
  };
  return res;
}

/**
 * @description Solicita ao modelo de IA (Gemini) a correção de uma resposta dissertativa com base nos dados da questão.
 * Suportado para questões do tipo SingleLineText e MultilineText.
 * Para questões MultilineText com subtipo configurado, a estratégia de correção varia conforme o subtipo:
 * - **OpinionArticle** (1): avalia tese, argumentação e conclusão.
 * - **Essay** (2): avalia conteúdo, completude, coesão e gramática.
 * - **ModelAnswerEssay** (3): compara à resposta-modelo e verifica os termos-chave. Requer `ModelAnswer` e `KeyTerms` cadastrados na questão.
 * - **MbaCase** (4): avalia à luz das Notas de Ensino. Requer `ModelAnswer` cadastrado na questão.
 * Retorna sugestão de nota e feedback detalhado sem salvar no banco. **(Requer Authorization para autenticação)**
 * @summary Correção de questão dissertativa por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/answer/:answerId/ai-correction}
 */
export async function postApiV1ExamAnswerAnsweridAiCorrection(
  answerId: PostApiV1ExamAnswerAnsweridAiCorrectionPathParams["answerId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1ExamAnswerAnsweridAiCorrectionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamAnswerAnsweridAiCorrection400
      | PostApiV1ExamAnswerAnsweridAiCorrection401
      | PostApiV1ExamAnswerAnsweridAiCorrection404
      | PostApiV1ExamAnswerAnsweridAiCorrection500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1ExamAnswerAnsweridAiCorrectionUrl(answerId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
